export default __webpack_public_path__ + "static/wave-b85f517c3ec9bf4bb10fb619d0a1289a.webm";